import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons';

const icons = { faCheckSquare, faCoffee };

export default icons;
